export default "__VITE_ASSET__0e40e842__"